import { Component } from '@angular/core';

@Component({
  selector: 'app-lt-tos-contents',
  templateUrl: './lt-tos-contents.component.html',
})
export class LithuanianTOSContentsComponent {}
